import commonMixin from './mixins/common'
import PartialAccount from './StepInfo/Account'
import PartialApplicant from './StepInfo/Applicant'
import PartialCoapplicant from './StepInfo/Coapplicant'
import PartialService from './StepInfo/Service'
import PartialTerms from './StepInfo/Terms'
import PartialCapitalFund from './StepInfo/CapitalFund'

export default {
  mixins: [commonMixin],

  components: {
    PartialAccount,
    PartialApplicant,
    PartialCoapplicant,
    PartialService,
    PartialTerms,
    PartialCapitalFund,
  },

  // language=HTML (for PhpStorm)
  template: `
    <ui-form
      ref="form"
      class="service-app"
      :model="model"
      :rules="validationRules"
      label-position="left"
      :label-columns="3"
      :input-columns="9"
    >
      <p>All fields are required unless specified otherwise.</p>

      <PartialAccount :model="model" />
      <PartialApplicant :model="model" />
      <PartialCoapplicant :model="model" v-if="model.account.ownership === 'Joint'" />
      <PartialService :model="model" />
      <PartialTerms :model="model" />
      <PartialCapitalFund :model="model" />

      <p>
        <button type="button" class="large primary button" @click="defaultGoToNextStep">Continue</button>
      </p>
    </ui-form>
  `,

  props: {
    model: Object,
    validationRules: Object,
    idParamsUrl: String,
  },

  methods: {},
}
